.cv{aspect-ratio:1/1;}